<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form @submit.prevent="filterPackageEmission" class="search-forms">
        <v-row class="mb-7">
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.search')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              hide-details
              clearable
            ></BaseTextField>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              type="submit"
              variant="filter"
              :loading="sendingPackagesLoading"
            >
              {{ $tc("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="mb-10"
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      :loading="sendingPackagesLoading"
      :headers="headers"
      :items="allSendingPackages.info"
      :items-per-page="10"
      mobile-breakpoint="0"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.package-emission.packages-per-page'),
      }"
    >
      <template v-slot:item.nome="{ item }">
        {{ item.nome || "-" }}
      </template>
      <template v-slot:item.taxa_pacote="{ item }">
        {{ formatCurrency(item.taxa_pacote) }}
      </template>
      <template v-slot:item.taxa_cortesia="{ item }">
        {{ formatCurrency(item.taxa_cortesia) }}
      </template>
      <template v-slot:item.taxa_gratuidade="{ item }">
        {{ formatCurrency(item.taxa_gratuidade) }}
      </template>

      <template
        v-for="(totais, index) in allSendingPackages.totals"
        v-slot:body.append
      >
        <tr :key="index" class="text-end font-weight-bold total-row">
          <td class="text-start">Total</td>
          <v-spacer></v-spacer>
          <td>{{ formatCurrency(totais.valor_total_taxa_pacote) }}</td>
          <td>{{ formatCurrency(totais.valor_total_taxa_cortesia) }}</td>
          <td>{{ formatCurrency(totais.valor_total_taxa_gratuidade) }}</td>
        </tr>
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { formatCurrency } from "@/utils/productPackage.js";
import dayjs from "dayjs";
import _ from "lodash";

import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "PackageEmission",
  components: {
    DateTimePicker,
    BaseTextField,
    BaseButton,
    ExpansionPanelFilters,
  },
  data() {
    return {
      formatCurrency,
      filter: {
        pesquisar: "",
        initDateTime: "",
        endDateTime: "",
      },
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
          loading: this.exportCSVLoading,
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
          loading: this.exportPDFLoading,
        },
      ],
      dayjs: dayjs,
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "allSendingPackages",
      "sendingPackagesLoading",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.order"),
          align: "start",
          sortable: false,
          value: "pedido",
        },
        {
          text: this.$t("reports.package-emission.name"),
          align: "start",
          value: "nome",
        },
        {
          text: this.$t("reports.package-emission.package-fee"),
          align: "end",
          value: "taxa_pacote",
        },
        {
          text: this.$t("reports.package-emission.courtesy-fee"),
          align: "end",
          value: "taxa_cortesia",
        },
        {
          text: this.$t("reports.package-emission.free-fee"),
          align: "end",
          value: "taxa_gratuidade",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchSendingPackages"]),
    ...mapMutations(["setSendingPackagesLoading", "setReportsFilter"]),
    filterPackageEmission() {
      this.setSendingPackagesLoading(true);
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        pesquisar: this.filter.pesquisar,
      });

      this.fetchSendingPackages(filter);
      this.setReportsFilter(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterPackageEmission();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
  },
  mounted() {
    if (this.storeSequencial) {
      this.fetchSendingPackages({
        producerId: this.storeSequencial,
      });
    }
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>
<style scoped></style>
